import api from "./api";
import qs from "qs";
import { PresignedPostData } from "~/components/RequestCreationModal/Uploader/types";

type CustomerRequestAttributes = {
    jobId: number;
    customerId: number;
    customerCode?: string;
    observation: string;
    reasonIds: Array<number>;
};

type GetRequest = {
    requestId?: number;
    jobId?: number;
};

type SignPostResponse = Record<string, any>;

type AttachmentSingProps = {
    key: string;
    maxLength: number;
};

export type File = {
    requestId: number;
    filePath: string;
    createdAt?: Date;
};

const Request = {
    async list({ filters = {}, page = 1 }) {
        const query = qs.stringify({ filters, page });
        return api.get(`/v1/job/requests?${query}`).then((res) => res.data);
    },
    async get({ requestId, jobId }: GetRequest) {
        const query = qs.stringify({ jobId });
        return api.get(`/v1/job/request/${requestId}?${query}`).then((res) => res.data);
    },
    async create(data: CustomerRequestAttributes) {
        return api.post(`/v1/job/request`, data).then((res) => res.data);
    },
    async reOpenRequest({ requestId, status = "aguardando" }) {
        return api.patch(`/v1/job/request/${requestId}`, { status });
    },
    async doneRequest({ requestId, userName = "", status = "resolvido" }) {
        const data = { userName, status, resolutionDate: new Date() };
        return api.patch(`/v1/job/request/${requestId}`, data);
    },

    async getMessages(requestId: number) {
        return api.get(`/v1/request/messages/${requestId}`).then((res) => res.data);
    },
    async createMessage({ requestId, customerId, message, sender = "cliente", destination }) {
        const data = { customerId, message, sender, destination };
        return api.post(`/v1/request/messages/${requestId}`, data);
    },

    async readMsg({ requestId, customerId, sender }) {
        return api.patch(`/v1/request/messages/${requestId}/${customerId}?sender=${sender}`);
    },
    async attachmentSing({ key, maxLength }: AttachmentSingProps): Promise<PresignedPostData> {
        const conditions = [["content-length-range", 0, maxLength]];
        return api.post(`/v1/job/request/attachment/sign`, { conditions, filename: key }).then( res => res.data)
    },
    async attachmentRegister(files:File[] ): Promise<SignPostResponse> {
        return api.post(`/v1/job/request/attachment/success`, { files }).then( res => res.data)
    }
};

export default Request;
